import globals from "./globalvars";

export function resize($item){

	$item.each(function() {
        // var main = $(this);
        var th,tw,im,ih,iw; 
        var nh,nw,hd,wd;
        
        $(this).find('.preload-img:not(.fixed)').each(function() {
            var main = $(this).closest('.fix_size');
            th = main.outerHeight(),//box height
            tw = main.outerWidth(),//box width
            im = $(this),//image
            ih = im.attr('height'),//inital image height
            iw = im.attr('width');//initial image width
        
        if ((th/tw) > (ih/iw)){
            im.addClass('wh').removeClass('ww');//set height 100%
        } else {
            im.addClass('ww').removeClass('wh');//set width 100%
        }
            
        });
        $(this).find('.wait').removeClass('wait');
    });
}

export function preload_fix(){
	$('.preload-img.load:not(.loaded)').each(function(index) {
		
		var the_item = $(this);
		var is_crm = false;
		if(the_item.hasClass('ignore')) return;

		if(the_item.attr('alt') == 'crm_image'){
			is_crm = true;
			// save crm image to wp media
			the_item.addClass('ignore');

			var data = {
				action: 'upload_image', 
				security : MyAjax.security, 
				data: {
					$size:the_item.attr('width'), 
					$crm_id:the_item.attr('height'), 
					$url:the_item.data('src'),
					$alt:the_item.data('alt')
				},
				dataType: "json",  
			};
			$.post(MyAjax.ajaxurl, data, function(response) {
			
			var object = JSON.parse(response);
				if(object != null){ 
					if('image_script' in object){
						var new_item = $(object.image_script);
						new_item.addClass('load');
						the_item.replaceWith(new_item);

						the_item = new_item;
						console.log('new_item_added');
						preload_fix();
					}
				}
			});

			return false; 
		}

		console.log('continue');
		the_item.addClass('loaded');
		
		var closet_parent = the_item.closest('.anim');
		var fix_size = the_item.closest('.fix_size');
		
		//get states
		var states = set_image_states(the_item);
		console.log(states);
	
		if(states != false){ 
		
		var tempsrc = states[0].src;
		var tempsrc_height = states[0].height;
		var tempsrc_width = states[0].width;
		var loaded = states[0].loaded; 
		var img = $('<img/>');
		img.attr('src', tempsrc).on('load', function() {
	
		
		img.remove();
			//resize();
			the_item.attr('src', tempsrc);
			the_item.attr('height', tempsrc_height);
			the_item.attr('width', tempsrc_width);
			the_item.data('loaded', loaded);
			resize(fix_size);
			the_item.addClass('show');
			gosvg();
			//group set
			if(closet_parent.hasClass('group')){
				var all_loaded = true;
				closet_parent.find('.load.preload-img').each(function(){
					if(!$(this).hasClass('show')){
						//wait
						all_loaded = false;
					}
				});
				if(all_loaded == true){
					closet_parent.addClass('group-ready');
				}
			}
			
			
		});
		
	}
		
	});
	
}

function set_image_states($item){
	var window_width = $('body').width() + globals.scrollbar_width;
	var the_item = $item;
	var tempsrc;
	var tempsrc_width;
	var tempsrc_height;
	var loaded = the_item.data('loaded');
	var prefix =  the_item.data('prefix');
	// console.log(the_item);
	// console.log('NEW++');
	//if intial load prevent temploaded interfereing 
	if(!loaded){
		loaded = 0;
	}
	
	
	var src = the_item.data('src'); 
	if(src){ 
		src = src.split(",");
	}
	
	var src_sm = the_item.data('src-sm'); 
	if(src_sm){
		src_sm = src_sm.split(",");
	}
	
	var src_md = the_item.data('src-md');
	if(src_md){
		src_md = src_md.split(",");
	}
	
	var src_lg = the_item.data('src-lg');
	if(src_lg){ 
		src_lg = src_lg.split(",");
	}
	
	if(window_width < 768 && loaded <= 1 ){
		if(src_sm){
			tempsrc = src_sm[0];
			tempsrc_width = src_sm[1];
			tempsrc_height = src_sm[2];
			loaded = 1; 
			// console.log('SM = ' + src_sm);
		} 
	}
	if(window_width >= 768 && window_width < 992  && loaded <= 2 ){
		if(src_md){
			tempsrc = src_md[0];
			tempsrc_width = src_md[1];
			tempsrc_height = src_md[2];
			loaded = 2;
			// console.log('MD = ' + src_md);
		}
	}
	if(window_width >= 992 && window_width < 1200  && loaded <= 3 ){
		if(src_lg){
			tempsrc = src_lg[0];
			tempsrc_width = src_lg[1];
			tempsrc_height = src_lg[2];
			loaded = 3;
			// console.log('LG = ' + src_lg);
		} 
	} 
	if(window_width >= 1200  && loaded <= 4){
		if(src){
			tempsrc = src[0];
			tempsrc_width = src[1];
			tempsrc_height = src[2];
			loaded = 4; 
			// console.log('XL = ' + src);
		}
	}
	
	if(prefix){
	var item_data = [{
		'src':prefix +'/'+ tempsrc,
		'width':tempsrc_width,
		'height':tempsrc_height,
		'loaded':loaded,
	}];
	} else {
	var item_data = [{
		'src':tempsrc,
		'width':tempsrc_width,
		'height':tempsrc_height,
		'loaded':loaded,
	}];
	}
	
	
	if(tempsrc){
		return item_data;
	} else {
		return false;
	}
}
	
var preload_fix_resizeTimeout;
$(window).on('resize', function(e){
	
	if(!!preload_fix_resizeTimeout){ clearTimeout(preload_fix_resizeTimeout); }
	preload_fix_resizeTimeout = setTimeout(function(){
		var window_width = $('body').width() + globals.scrollbar_width;
		$('.anim.go .preload-img.loaded').each(function(index) {
			var the_item = $(this);
			var fix_size = the_item.closest('.fix_size');
			
			//get states
			var states = set_image_states(the_item);
			
			
			if(states != false){ 
				var tempsrc = states[0].src;
				var tempsrc_height = states[0].height;
				var tempsrc_width = states[0].width;
				var loaded = states[0].loaded; 
				
				
				// the_item.data('loaded', new_loaded);
				the_item.attr('src', tempsrc);
				the_item.attr('height', tempsrc_height);
				the_item.attr('width', tempsrc_width);
				the_item.data('loaded', loaded);
				resize(fix_size); 
			}
			
		});
		
	},200);
});


function gosvg(){
	// If force inline SVG option is active then add class
	if ( $.ForceInlineSVGActive === 'true' ) {

		// Find all SVG inside img and add class if it hasn't got it
		jQuery('img').each(function() {

			// Pick only those with the extension we want
			if ( jQuery(this).attr('src').match(/\.(svg)/) ) {

				// Add our class name
				if ( !jQuery(this).hasClass($.cssTarget.ForceInlineSVG) ) {
					jQuery(this).addClass($.cssTarget.ForceInlineSVG);
				}
			}
		});
	}

	// Polyfill to support all ye old browsers
	// delete when not needed in the future
	if (!String.prototype.endsWith) {
		String.prototype.endsWith = function(searchString, position) {
			var subjectString = this.toString();
			if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
				position = subjectString.length;
			}
			position -= searchString.length;
			var lastIndex = subjectString.lastIndexOf(searchString, position);
			return lastIndex !== -1 && lastIndex === position;
		};
	} // end polyfill

	// Another snippet to support IE11
	String.prototype.endsWith = function(pattern) {
		var d = this.length - pattern.length;
		return d >= 0 && this.lastIndexOf(pattern) === d;
	};
	// End snippet to support IE11

	// Check to see if user set alternate class
	if ( $.ForceInlineSVGActive === 'true' ) {
		var target  = ( $.cssTarget.Bodhi !== 'img.' ? $.cssTarget.Bodhi : 'img.style-svg' );
	} else {
		var target  = ( $.cssTarget !== 'img.' ? $.cssTarget : 'img.style-svg' );
	}

	$(target).each(function(index){
		var $img = jQuery(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		// Set svg size to the original img size
		// var imgWidth = $img.attr('width');
		// var imgHeight = $img.attr('height');

		if (!imgURL.endsWith('svg')) {
			return;
		}

		$.get(imgURL, function(data) {

			// Get the SVG tag, ignore the rest
			var $svg = $(data).find('svg');

			var svgID = $svg.attr('id');

			// Add replaced image's ID to the new SVG if necessary
			if(typeof imgID === 'undefined') {
				if(typeof svgID === 'undefined') {
					imgID = 'svg-replaced-'+index;
					$svg = $svg.attr('id', imgID);
				} else {
					imgID = svgID;
				}
			} else {
				$svg = $svg.attr('id', imgID);
			}

			// Add replaced image's classes to the new SVG
			if(typeof imgClass !== 'undefined') {
				$svg = $svg.attr('class', imgClass+' replaced-svg svg-replaced-'+index);
			}

			// Remove any invalid XML tags as per http://validator.w3.org
			$svg = $svg.removeAttr('xmlns:a');

			// Add size attributes
			// $svg = $svg.attr('width', imgWidth);
			// $svg = $svg.attr('height', imgHeight);

			// Replace image with new SVG
			$img.replaceWith($svg);

			$(document).trigger('svg.loaded', [imgID]);

		}, 'xml');
	});
}

$(window).on('resize', function(e){
	resize($(' .fix_size'));
}); 
$(window).on('load', function(){
	resize($(' .fix_size'));
});